import DesUserListViewModel from 'viewmodel/DesUserListViewModel'
import {
    DesBaseCatalogAcc
} from '../utils/des-base-catalog-acc';

export default class DesUserList extends DesBaseCatalogAcc {
    constructor() {
        super(DesUserListViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale'];
    }
}

if (!window.customElements.get('des-user-list')) {
    window.customElements.define('des-user-list', DesUserList);
}
